import { render, staticRenderFns } from "./MainAlert.vue?vue&type=template&id=0a9b65da&scoped=true&"
import script from "./MainAlert.vue?vue&type=script&lang=ts&"
export * from "./MainAlert.vue?vue&type=script&lang=ts&"
import style0 from "./MainAlert.vue?vue&type=style&index=0&id=0a9b65da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b65da",
  null
  
)

export default component.exports